import { render, staticRenderFns } from "./weekleyReports.vue?vue&type=template&id=2f27e01e&scoped=true"
import script from "./weekleyReports.vue?vue&type=script&lang=js"
export * from "./weekleyReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27e01e",
  null
  
)

export default component.exports